export enum InternalRegistrationVerticalEnum {
    accounting = 'Accounting',
    architecture = 'Architecture & Interior Design',
    automotive = 'Automotive',
    business_consultancy = 'Business Consultancy',
    construction = 'Construction',
    d2c = 'D2C / E-commerce',
    design = 'Design & Creative',
    distribution = 'Distribution & Logistics',
    education = 'Education',
    event_management = 'Event Management',
    facility_management = 'Facility Management',
    financial_services = 'Financial Services',
    FMCG = 'FMCG',
    game = 'Game Development',
    government = 'Government',
    healthcare = 'Healthcare',
    hr_recruitment = 'HR & Recruitment',
    incubators = 'Incubators / Accelerators',
    legal = 'Legal Services',
    manufacturing = 'Manufacturing',
    marketing = 'Marketing Services',
    non_profit = 'Non Profit (NGO)',
    operations = 'Operations',
    personal = 'Personal',
    pharma = 'Pharma',
    real_estate = 'Real Estate',
    saas = 'SaaS',
    sales_crm = 'Sales & CRM',
    software = 'Software Services',
    solar = 'Solar',
    system_integrators = 'System Integrators',
    travel = 'Travel & Hospitality',
    
    others = 'Others',
}